import { render, staticRenderFns } from "./IndexSimples.vue?vue&type=template&id=1e63cc04&"
import script from "./IndexSimples.vue?vue&type=script&lang=js&"
export * from "./IndexSimples.vue?vue&type=script&lang=js&"
import style0 from "./IndexSimples.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports